export const ALPHA_CHARS = "abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
export const ALPHA_NUMERIC_CHARS = `0123456789${ALPHA_CHARS}`
export const SPECIAL_CHARS = `${ALPHA_NUMERIC_CHARS}!@#$%^&*()`

export function generateRandomString(passwordOptions: {
  minLength?: number,
  maxLength?: number,
  characters?: string,
} = {}): string {
  const minLength = passwordOptions.minLength ? passwordOptions.minLength : 10
  const maxLength = passwordOptions.maxLength ? passwordOptions.maxLength : 30
  const passwordChars = passwordOptions.characters ? passwordOptions.characters : SPECIAL_CHARS

  let password = ""
  const passwordLength = Math.random() * (maxLength - minLength) + minLength
  for (let i = 0; i < passwordLength; i++) {
    password += passwordChars.charAt(Math.floor(Math.random() * passwordChars.length))
  }

  return password
}
